module.exports = __webpack_public_path__ + "img/refundImg.f6e77a54.png";